<template>
  <b-modal title="Informações do Instrumento" v-model="show" size="lg">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Descrição:" label-for="descricao" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="descricao" v-model="editing.descricao" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Fabricante:" label-for="fabricante" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="fabricante" v-model="editing.fabricante" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Série:" label-for="serie" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="serie" v-model="editing.serie" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Modelo:" label-for="modelo" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="modelo" v-model="editing.modelo" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Capacidade:" label-for="capacidade" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="capacidade" v-model="editing.capacidade" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="11">
          <b-form-group label="Certificado:" label-for="certificado" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="certificado" v-model="editing.certificado" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="11">
          <b-form-group label-cols-sm="3" label="Calibração:" label-align-sm="right" label-for="calibracao">
            <b-form-datepicker
              id="calibracao"
              v-model="editing.calibracao"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <template #modal-footer>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import Instrumento from "@/models/Instrumento";
import Notificacao from "@/models/Notificacao";
import { useSgcqStore } from "@/stores/SgcqStore";
import { useInstrumentoStore } from "@/stores/InstrumentoStore";

export default {
  name: "ModalDeEdicaoDeInstrumento",

  data() {
    return {
      editing: new Instrumento(),
      show: false,
    };
  },

  methods: {
    salvar() {
      if (this.editing.id != 0) {
        this.instrumentoStore.ALTERAR_INSTRUMENTO(this.editing).then(() => {
          this.store.NOTIFICAR(new Notificacao("Instrumento salvo no SGCQ com sucesso!", "Excelente!", "success"));
        });
      } else {
        this.instrumentoStore
          .CADASTRAR_INSTRUMENTO(this.editing)
          .then(() => this.store.NOTIFICAR(new Notificacao("Instrumento salvo no SGCQ com sucesso!", "Excelente!", "success")));
      }
      this.show = !this.show;
    },

    call(instrumento) {
      this.editing = instrumento;
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();
    const instrumentoStore = useInstrumentoStore();

    return {
      store,
      instrumentoStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
